import { Component, inject, input } from '@angular/core';
import { AssetReaderService } from '@core/lp/asset-reader.service';
import { LpItemContentElement } from '@typings/lp/generated';

@Component({
  selector: 'lp-inventory-item-content',
  imports: [],
  templateUrl: './lp-inventory-item-content.component.html',
  styleUrl: './lp-inventory-item-content.component.css',
})
export class LpInventoryItemContentComponent {
  readonly _assetReaderService = inject(AssetReaderService);

  contents = input.required<LpItemContentElement[]>();
}
